var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ReportBasic", {
        ref: "BasicInfoRef",
        on: { goEntryManagementPage: _vm.goEntryManagementPage },
      }),
      _c(
        "vab-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, disabled: !_vm.showBtn },
        },
        [
          _c(
            "div",
            { staticClass: "mt16 rc_boxshadow shadow_boxpadding" },
            [
              _c("vab-filerc", { ref: "vabFile" }, [
                _c("div", { attrs: { slot: "h_title" }, slot: "h_title" }, [
                  _vm._v("報告書の提出を行ってください"),
                ]),
              ]),
            ],
            1
          ),
          _vm.isEquipment
            ? _c(
                "div",
                [
                  _vm._l(
                    _vm.changerWquipmentList(_vm.form.reportDetailRcModelList),
                    function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "mt24 rc_boxshadow shadow_boxpadding",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "head_box flex_start flex_center_align",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function ($event) {
                                  return _vm.isShow(item, index)
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/images/r2.png"),
                                  alt: "",
                                },
                              }),
                              _c(
                                "span",
                                { staticClass: "hd_title" },
                                [
                                  _vm._t("hd_title", function () {
                                    return [
                                      _vm._v("作業報告" + _vm._s(item.workNo)),
                                    ]
                                  }),
                                ],
                                2
                              ),
                              _c("div", { staticClass: "pos_end" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "arrow_box flex_center_align flex_center",
                                  },
                                  [
                                    _c("svg-icon", {
                                      staticClass: "arrow_svg",
                                      class: { rote: item.workFold },
                                      attrs: { "icon-class": "up_line" },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.workFold,
                                  expression: "item.workFold",
                                },
                              ],
                              staticClass: "scd_cnt_box",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "row_out_box mt12" },
                                [
                                  _c(
                                    "vab-row",
                                    { staticClass: "row_box" },
                                    [
                                      _c(
                                        "vab-col",
                                        {
                                          staticClass: "title_box bdt0",
                                          attrs: { span: 4 },
                                        },
                                        [
                                          _vm._v(" 作業No "),
                                          _c("i", { staticClass: "red" }, [
                                            _vm._v("*"),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "vab-col",
                                        {
                                          staticClass:
                                            "word_box word_col_input bdt0",
                                          attrs: { span: 20 },
                                        },
                                        [
                                          _c("vab-select", {
                                            staticClass: "width160",
                                            attrs: {
                                              "label-width": "0",
                                              prop:
                                                "reportDetailRcModelList." +
                                                index +
                                                ".workNo",
                                              "data-items": _vm.workNoList,
                                              "label-id": "workNo",
                                              "value-id": "workNo",
                                              placeholder: "",
                                              clearable: "",
                                              "collapse-tags": "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "vab-row",
                                    { staticClass: "row_box" },
                                    [
                                      _c(
                                        "vab-col",
                                        {
                                          staticClass: "title_box",
                                          attrs: { span: 4 },
                                        },
                                        [
                                          _vm._v(" 棟 "),
                                          _c("i", { staticClass: "red" }, [
                                            _vm._v("*"),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "vab-col",
                                        {
                                          staticClass:
                                            "word_box word_col_input",
                                          attrs: { span: 20 },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "build_section" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "build_section_item",
                                                },
                                                [
                                                  _c("vab-select", {
                                                    staticClass: "wid80",
                                                    attrs: {
                                                      "label-width": "0",
                                                      prop:
                                                        "reportDetailRcModelList." +
                                                        index +
                                                        ".reportSectionCd",
                                                      "data-items":
                                                        _vm.mbuildList,
                                                      "label-id": "bldgcd",
                                                      "value-id": "bldgcd",
                                                      clearable: "",
                                                      "collapse-tags": "",
                                                      placeholder: "",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.handlemBuildListChange(
                                                          item,
                                                          index
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "build_section_item",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.blgsnmkj) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "vab-row",
                                    { staticClass: "row_box" },
                                    [
                                      _c(
                                        "vab-col",
                                        {
                                          staticClass: "title_box",
                                          attrs: { span: 4 },
                                        },
                                        [_vm._v("前回作業No")]
                                      ),
                                      _c(
                                        "vab-col",
                                        {
                                          staticClass: "word_box",
                                          attrs: { span: 20 },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getFieldValue(
                                                  "lastReportDetailRc.workNo",
                                                  item
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._l(
                                item.equipmentInspectionModelList,
                                function (son, sonIndex) {
                                  return _c("div", { key: sonIndex }, [
                                    _c(
                                      "div",
                                      { staticClass: "row_out_box mt12" },
                                      [
                                        _c(
                                          "vab-row",
                                          { staticClass: "row_box" },
                                          [
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box word_col_title bdt0 bdr0",
                                                attrs: { span: 24 },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "low_box" },
                                                  [
                                                    _vm._v(
                                                      " 総合設備点検結果" +
                                                        _vm._s(sonIndex + 1) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass: "title_box",
                                                attrs: { span: 4 },
                                              },
                                              [
                                                _vm._v(" 対応状況 "),
                                                _c(
                                                  "i",
                                                  { staticClass: "red" },
                                                  [_vm._v("*")]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box nopadding2 word_flex",
                                                attrs: { span: 20 },
                                              },
                                              [
                                                _c("vab-radio-group", {
                                                  ref: "workReportRef" + index,
                                                  refInFor: true,
                                                  attrs: {
                                                    label: "",
                                                    "label-width": "0",
                                                    prop:
                                                      "reportDetailRcModelList." +
                                                      index +
                                                      ".responseStatus",
                                                    filter: "responseStatus",
                                                    "code-enum":
                                                      _vm.$divisions
                                                        .dealingFlgEnum,
                                                  },
                                                }),
                                                _vm.showBtn
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "delete",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteEquipmentResultList(
                                                              index,
                                                              son
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(" 削除 ")]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "vab-row",
                                          { staticClass: "row_box" },
                                          [
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box flex_col bg",
                                                attrs: { span: 4 },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex_col_title",
                                                  },
                                                  [_vm._v("報告内容")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    class: [
                                                      _vm.defectiveNoClass(son)
                                                        ? "fault_no_btn"
                                                        : "fault_no_btn_disabled fault_no_btn",
                                                      !_vm.showBtn
                                                        ? "fault_no_btn_disabled fault_no_btn"
                                                        : "",
                                                    ],
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.failureNoDialog(
                                                          son,
                                                          index,
                                                          sonIndex
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 不具合No ")]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box word_col_input",
                                                attrs: { span: 8 },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "mb8 line15" },
                                                  [
                                                    _vm._v(
                                                      " 不具合No： " +
                                                        _vm._s(
                                                          _vm.defectNoFormat(
                                                            son.defectiveNo
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "line15 pre_wrap",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.reportContent)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box title_box",
                                                attrs: { span: 4 },
                                              },
                                              [_vm._v(" 報告内容（前回） ")]
                                            ),
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box word_col_input line15",
                                                attrs: { span: 8 },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "mb8 line15" },
                                                  [
                                                    _vm._v(
                                                      " 不具合No： " +
                                                        _vm._s(
                                                          _vm.defectNoFormat(
                                                            _vm.getFieldValue(
                                                              "lastReportDetailRc.equipmentInspectionModelList[" +
                                                                sonIndex +
                                                                "].defectiveNo",
                                                              item
                                                            )
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "line15 pre_wrap",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.getFieldValue(
                                                            "lastReportDetailRc.equipmentInspectionModelList[" +
                                                              sonIndex +
                                                              "].reportContent",
                                                            item
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "vab-row",
                                          { staticClass: "row_box" },
                                          [
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box title_box",
                                                attrs: { span: 4 },
                                              },
                                              [_vm._v(" 点検リスト分類 ")]
                                            ),
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box word_col_input",
                                                attrs: { span: 20 },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex_select_box",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "select_box_item",
                                                      },
                                                      [
                                                        _c("vab-select", {
                                                          staticClass:
                                                            "flex_select1",
                                                          attrs: {
                                                            label: "分類1",
                                                            "label-width":
                                                              "50px",
                                                            prop:
                                                              "reportDetailRcModelList." +
                                                              index +
                                                              ".equipmentInspectionModelList." +
                                                              sonIndex +
                                                              ".inspectionList1Cd",
                                                            "data-items":
                                                              son.inspectionList1CdList,
                                                            "label-id":
                                                              "inlstbr1cd",
                                                            "value-id":
                                                              "inlstbr1cd",
                                                            disabled:
                                                              !_vm.$baseLodash.trim(
                                                                item.reportSectionCd
                                                              ),
                                                            placeholder: "",
                                                            "collapse-tags": "",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.inspectionList1CdChange(
                                                                son,
                                                                item
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    son.inspectionList1Cd
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "select_box_icon",
                                                          },
                                                          [
                                                            _c("svg-icon", {
                                                              staticClass:
                                                                "arrow_svg_right",
                                                              attrs: {
                                                                "icon-class":
                                                                  "right_line",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    son.inspectionList1Cd
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "select_box_item",
                                                          },
                                                          [
                                                            _c("vab-select", {
                                                              staticClass:
                                                                "flex_select1",
                                                              attrs: {
                                                                label: "分類2",
                                                                "label-width":
                                                                  "50px",
                                                                prop:
                                                                  "reportDetailRcModelList." +
                                                                  index +
                                                                  ".equipmentInspectionModelList." +
                                                                  sonIndex +
                                                                  ".inspectionList2Cd",
                                                                "data-items":
                                                                  son.inspectionList2CdList,
                                                                "label-id":
                                                                  "inlstbr2cd",
                                                                "value-id":
                                                                  "inlstbr2cd",
                                                                placeholder: "",
                                                                "collapse-tags":
                                                                  "",
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.inspectionList2CdChange(
                                                                      son,
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    son.inspectionList2Cd
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "select_box_icon",
                                                          },
                                                          [
                                                            _c("svg-icon", {
                                                              staticClass:
                                                                "arrow_svg_right",
                                                              attrs: {
                                                                "icon-class":
                                                                  "right_line",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    son.inspectionList2Cd
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "select_box_item",
                                                          },
                                                          [
                                                            _c("vab-select", {
                                                              staticClass:
                                                                "flex_select1",
                                                              attrs: {
                                                                label: "分類3",
                                                                "label-width":
                                                                  "50px",
                                                                prop:
                                                                  "reportDetailRcModelList." +
                                                                  index +
                                                                  ".equipmentInspectionModelList." +
                                                                  sonIndex +
                                                                  ".inspectionList3Cd",
                                                                "data-items":
                                                                  son.inspectionList3CdList,
                                                                "label-id":
                                                                  "inlstbr3cd",
                                                                "value-id":
                                                                  "inlstbr3cd",
                                                                placeholder: "",
                                                                "collapse-tags":
                                                                  "",
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.inspectionList3CdChange(
                                                                      son
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "normal_words mt8",
                                                  },
                                                  [
                                                    _vm._v(" 分類名： "),
                                                    son.br1nm
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                son.br1nm
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    son.br2nm
                                                      ? _c(
                                                          "span",
                                                          [
                                                            _c("svg-icon", {
                                                              staticClass:
                                                                "arrow_svg_right",
                                                              attrs: {
                                                                "icon-class":
                                                                  "right_line",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    son.br2nm
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                son.br2nm
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    son.br3nm
                                                      ? _c(
                                                          "span",
                                                          [
                                                            _c("svg-icon", {
                                                              staticClass:
                                                                "arrow_svg_right",
                                                              attrs: {
                                                                "icon-class":
                                                                  "right_line",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    son.br3nm
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                son.br3nm
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "vab-row",
                                          { staticClass: "row_box" },
                                          [
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box title_box",
                                                attrs: { span: 4 },
                                              },
                                              [_vm._v(" 点検番号 ")]
                                            ),
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box word_col_input",
                                                attrs: { span: 20 },
                                              },
                                              [
                                                _c("vab-input", {
                                                  staticClass: "flex_input1",
                                                  attrs: {
                                                    maxlength: "4",
                                                    prop:
                                                      "reportDetailRcModelList." +
                                                      index +
                                                      ".equipmentInspectionModelList." +
                                                      sonIndex +
                                                      ".inspectionItemsNo",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "vab-row",
                                          { staticClass: "row_box" },
                                          [
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box title_box",
                                                attrs: { span: 4 },
                                              },
                                              [_vm._v(" 該当箇所 ")]
                                            ),
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box word_col_input",
                                                attrs: { span: 20 },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "flex_input" },
                                                  [
                                                    _c("vab-input", {
                                                      directives: [
                                                        {
                                                          name: "input",
                                                          rawName:
                                                            "v-input.num",
                                                          modifiers: {
                                                            num: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "flex_input1",
                                                      attrs: {
                                                        maxlength: "3",
                                                        prop:
                                                          "reportDetailRcModelList." +
                                                          index +
                                                          ".equipmentInspectionModelList." +
                                                          sonIndex +
                                                          ".machineNo",
                                                      },
                                                      on: {
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          return _vm.blurNoInput(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "input_unit",
                                                      },
                                                      [_vm._v("号機")]
                                                    ),
                                                    _c("vab-input", {
                                                      staticClass:
                                                        "flex_input2",
                                                      attrs: {
                                                        label: "部位",
                                                        maxlength: "40",
                                                        "label-width": "40px",
                                                        prop:
                                                          "reportDetailRcModelList." +
                                                          index +
                                                          ".equipmentInspectionModelList." +
                                                          sonIndex +
                                                          ".position",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "vab-row",
                                          { staticClass: "row_box" },
                                          [
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box title_box",
                                                attrs: { span: 4 },
                                              },
                                              [_vm._v("数値")]
                                            ),
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box word_col_input",
                                                attrs: { span: 8 },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "flex_input" },
                                                  [
                                                    _c("vab-input", {
                                                      directives: [
                                                        {
                                                          name: "input",
                                                          rawName:
                                                            "v-input.float",
                                                          value: 2,
                                                          expression: "2",
                                                          modifiers: {
                                                            float: true,
                                                          },
                                                        },
                                                        {
                                                          name: "numberFormat",
                                                          rawName:
                                                            "v-numberFormat.float",
                                                          value: 2,
                                                          expression: "2",
                                                          modifiers: {
                                                            float: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "flex_input1 flex_input_num",
                                                      attrs: {
                                                        prop:
                                                          "reportDetailRcModelList." +
                                                          index +
                                                          ".equipmentInspectionModelList." +
                                                          sonIndex +
                                                          ".meterValue",
                                                        validate:
                                                          "range:0|99999.99",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box title_box",
                                                attrs: { span: 4 },
                                              },
                                              [_vm._v(" 数値（前回） ")]
                                            ),
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass: "word_box line15",
                                                attrs: { span: 8 },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formatNumber(
                                                        _vm.getFieldValue(
                                                          "lastReportDetailRc.equipmentInspectionModelList[" +
                                                            sonIndex +
                                                            "].meterValue",
                                                          item
                                                        ),
                                                        "0,0.00"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "vab-row",
                                          { staticClass: "row_box" },
                                          [
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box title_box",
                                                attrs: { span: 4 },
                                              },
                                              [_vm._v(" 経過年数 ")]
                                            ),
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass: "word_box line15",
                                                attrs: { span: 8 },
                                              },
                                              [
                                                son.usestrym
                                                  ? [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(son.usestrym) +
                                                          " "
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box title_box",
                                                attrs: { span: 4 },
                                              },
                                              [_vm._v(" 耐用年数 ")]
                                            ),
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass: "word_box line15",
                                                attrs: { span: 8 },
                                              },
                                              [
                                                son.taiyy && son.taiym
                                                  ? [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(son.taiyy) +
                                                          "年" +
                                                          _vm._s(son.taiym) +
                                                          "ヶ月 "
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "vab-row",
                                          { staticClass: "row_box" },
                                          [
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box title_box",
                                                attrs: { span: 4 },
                                              },
                                              [_vm._v("写真")]
                                            ),
                                            _c(
                                              "vab-col",
                                              {
                                                staticClass:
                                                  "word_box word_col_input word_col_upload",
                                                attrs: { span: 20 },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "word_bgF7" },
                                                  [
                                                    _vm.showBtn
                                                      ? _c("vab-upload", {
                                                          ref:
                                                            "equipmentRef" +
                                                            index +
                                                            sonIndex,
                                                          refInFor: true,
                                                          attrs: {
                                                            "upload-url":
                                                              "/api/defectPhoto/uploadFile",
                                                            "params-data": {
                                                              equipmentInspectionId:
                                                                son.equipmentInspectionId,
                                                              reportNo:
                                                                _vm.reportNo,
                                                              reportId:
                                                                _vm.reportId,
                                                              buildingCd:
                                                                _vm
                                                                  .currentBascInfo
                                                                  .buildingCd,
                                                            },
                                                            "action-item": {
                                                              item: item,
                                                              index: index,
                                                              sonIndex:
                                                                sonIndex,
                                                            },
                                                            "init-before": false,
                                                          },
                                                          on: {
                                                            "on-success":
                                                              function (res) {
                                                                return _vm.successPhotoFile(
                                                                  res,
                                                                  index,
                                                                  sonIndex
                                                                )
                                                              },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    son.defectPhotoModelList &&
                                                    _vm.changeFileList(
                                                      son.defectPhotoModelList
                                                    ).length
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "word_col_upload_filebox",
                                                          },
                                                          _vm._l(
                                                            _vm.changeFileList(
                                                              son.defectPhotoModelList
                                                            ),
                                                            function (file, f) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: f,
                                                                  staticClass:
                                                                    "file_inner_item flex_start",
                                                                },
                                                                [
                                                                  _c(
                                                                    "svg-icon",
                                                                    {
                                                                      staticClass:
                                                                        "arrow",
                                                                      attrs: {
                                                                        "icon-class":
                                                                          "tryangle_right",
                                                                      },
                                                                    }
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "file_name_out_box",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "flex_colum file_name_box",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "file_name",
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.defectPhotoDownLoad(
                                                                                      son,
                                                                                      file
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    file.photoName
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "file_time",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " アップロード日時：" +
                                                                                  _vm._s(
                                                                                    file.createDate
                                                                                  ) +
                                                                                  " " +
                                                                                  _vm._s(
                                                                                    file.createTime.substring(
                                                                                      0,
                                                                                      8
                                                                                    )
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm.showBtn
                                                                            ? _c(
                                                                                "svg-icon",
                                                                                {
                                                                                  staticClass:
                                                                                    "del",
                                                                                  attrs:
                                                                                    {
                                                                                      "icon-class":
                                                                                        "close_circle_fill",
                                                                                    },
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.handleEqumentDefectPhotoDelete(
                                                                                          file,
                                                                                          item,
                                                                                          index,
                                                                                          sonIndex,
                                                                                          f
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                }
                                                                              )
                                                                            : _vm._e(),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                }
                              ),
                            ],
                            2
                          ),
                        ]
                      )
                    }
                  ),
                  _vm.showBtn
                    ? _c("div", { staticClass: "row_btm_btn" }, [
                        _c(
                          "span",
                          {
                            staticClass: "defect_addition mt12",
                            on: { click: _vm.addWorkNoReportList },
                          },
                          [
                            _c("svg-icon", { attrs: { "icon-class": "add" } }),
                            _vm._v(" 作業報告を追加 "),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _c(
                "div",
                [
                  _vm._l(
                    _vm.form.reportDetailRcModelList,
                    function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "mt16 rc_boxshadow shadow_boxpadding",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "head_box flex_start flex_center_align",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function ($event) {
                                  return _vm.isShow(item, index)
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/images/r2.png"),
                                  alt: "",
                                },
                              }),
                              _c(
                                "span",
                                { staticClass: "hd_title" },
                                [
                                  _vm._t("hd_title", function () {
                                    return [
                                      _vm._v("作業報告" + _vm._s(item.workNo)),
                                    ]
                                  }),
                                ],
                                2
                              ),
                              _c("div", { staticClass: "pos_end pointer" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "arrow_box flex_center_align flex_center",
                                  },
                                  [
                                    _c("svg-icon", {
                                      staticClass: "arrow_svg",
                                      class: { rote: item.workFold },
                                      attrs: { "icon-class": "up_line" },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.workFold,
                                  expression: "item.workFold",
                                },
                              ],
                              staticClass: "scd_cnt_box mt12",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "row_out_box" },
                                [
                                  _c(
                                    "vab-row",
                                    { staticClass: "row_box" },
                                    [
                                      _c(
                                        "vab-col",
                                        {
                                          staticClass: "title_box bdt0",
                                          attrs: { span: 4 },
                                        },
                                        [
                                          _vm._v(" 作業No "),
                                          _c("i", { staticClass: "red" }, [
                                            _vm._v("*"),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "vab-col",
                                        {
                                          staticClass:
                                            "word_box word_col_input bdt0",
                                          attrs: { span: 20 },
                                        },
                                        [
                                          _c("vab-select", {
                                            staticClass: "width160",
                                            attrs: {
                                              "label-width": "0",
                                              prop:
                                                "reportDetailRcModelList." +
                                                index +
                                                ".workNo",
                                              "data-items": _vm.workNoList,
                                              validate: "required",
                                              "label-id": "workNo",
                                              "value-id": "workNo",
                                              placeholder: "",
                                              clearable: "",
                                              "collapse-tags": "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "vab-row",
                                    { staticClass: "row_box" },
                                    [
                                      _c(
                                        "vab-col",
                                        {
                                          staticClass: "title_box",
                                          attrs: { span: 4 },
                                        },
                                        [
                                          _vm._v(" 棟 "),
                                          _c("i", { staticClass: "red" }, [
                                            _vm._v("*"),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "vab-col",
                                        {
                                          staticClass:
                                            "word_box word_col_input",
                                          attrs: { span: 20 },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "build_section" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "build_section_item",
                                                },
                                                [
                                                  _c("vab-select", {
                                                    staticClass: "wid80",
                                                    attrs: {
                                                      "label-width": "0",
                                                      prop:
                                                        "reportDetailRcModelList." +
                                                        index +
                                                        ".reportSectionCd",
                                                      "data-items":
                                                        _vm.mbuildList,
                                                      "label-id": "bldgcd",
                                                      validate: "required",
                                                      "value-id": "bldgcd",
                                                      clearable: "",
                                                      "collapse-tags": "",
                                                      placeholder: "",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.handlemBuildListChange(
                                                          item,
                                                          index
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "build_section_item",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.blgsnmkj) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "vab-row",
                                    { staticClass: "row_box" },
                                    [
                                      _c(
                                        "vab-col",
                                        {
                                          staticClass: "title_box",
                                          attrs: { span: 4 },
                                        },
                                        [
                                          _vm._v(" 対応状況 "),
                                          _c("i", { staticClass: "red" }, [
                                            _vm._v("*"),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "vab-col",
                                        {
                                          staticClass:
                                            "word_box nopadding2 flex_center_align",
                                          attrs: { span: 20 },
                                        },
                                        [
                                          _c("vab-radio-group", {
                                            ref: "workReportRef" + index,
                                            refInFor: true,
                                            attrs: {
                                              prop:
                                                "reportDetailRcModelList." +
                                                index +
                                                ".responseStatus",
                                              validate: "required",
                                              filter: "responseStatus",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.responseStatusFilter(
                                                  item,
                                                  index
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  !_vm.isEqualCodeEnum(
                                    item.responseStatus,
                                    _vm.$divisions.responseStatusEnum.enum_3
                                  )
                                    ? _c(
                                        "vab-row",
                                        { staticClass: "row_box" },
                                        [
                                          _c("vab-col", {
                                            staticClass: "word_box title_box",
                                            attrs: { span: 4 },
                                          }),
                                          _c(
                                            "vab-col",
                                            {
                                              staticClass:
                                                "word_box word_col_title",
                                              attrs: { span: 10 },
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "low_box" },
                                                [_vm._v("今回")]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "vab-col",
                                            {
                                              staticClass:
                                                "word_box word_col_title",
                                              attrs: { span: 10 },
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "low_box" },
                                                [_vm._v("前回")]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  !_vm.isEqualCodeEnum(
                                    item.responseStatus,
                                    _vm.$divisions.responseStatusEnum.enum_3
                                  )
                                    ? _c(
                                        "vab-row",
                                        { staticClass: "row_box" },
                                        [
                                          _c(
                                            "vab-col",
                                            {
                                              staticClass: "word_box title_box",
                                              attrs: { span: 4 },
                                            },
                                            [_vm._v("報告内容")]
                                          ),
                                          _c(
                                            "vab-col",
                                            {
                                              staticClass:
                                                "word_box word_col_input",
                                              attrs: { span: 10 },
                                            },
                                            [
                                              _c("vab-textarea", {
                                                staticClass: "height100",
                                                attrs: {
                                                  prop:
                                                    "reportDetailRcModelList." +
                                                    index +
                                                    ".reportContent",
                                                  maxlength: "1170",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "vab-col",
                                            {
                                              staticClass:
                                                "word_box word_col_cont",
                                              attrs: { span: 10 },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getFieldValue(
                                                      "lastReportDetailRc.reportContent",
                                                      item
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  !_vm.isEqualCodeEnum(
                                    item.responseStatus,
                                    _vm.$divisions.responseStatusEnum.enum_3
                                  ) &&
                                  _vm.isEqualCodeEnum(
                                    _vm.adjSourceClass,
                                    _vm.$divisions.adjSourceClassEnum.enum_2
                                  )
                                    ? _c(
                                        "vab-row",
                                        { staticClass: "row_box" },
                                        [
                                          _c(
                                            "vab-col",
                                            {
                                              staticClass: "word_box title_box",
                                              attrs: { span: 4 },
                                            },
                                            [_vm._v("対処内容")]
                                          ),
                                          _c(
                                            "vab-col",
                                            {
                                              staticClass:
                                                "word_box word_col_input heightNormal",
                                              attrs: { span: 10 },
                                            },
                                            [
                                              _c("vab-textarea", {
                                                attrs: {
                                                  prop:
                                                    "reportDetailRcModelList." +
                                                    index +
                                                    ".reportDealContent",
                                                  maxlength: "1170",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "vab-col",
                                            {
                                              staticClass:
                                                "word_box word_col_input",
                                              attrs: { span: 10 },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getFieldValue(
                                                      "lastReportDetailRc.reportDealContent",
                                                      item
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  !_vm.isEqualCodeEnum(
                                    item.responseStatus,
                                    _vm.$divisions.responseStatusEnum.enum_3
                                  ) &&
                                  _vm.isEqualCodeEnum(
                                    _vm.adjSourceClass,
                                    _vm.$divisions.adjSourceClassEnum.enum_2
                                  )
                                    ? _c(
                                        "vab-row",
                                        { staticClass: "row_box" },
                                        [
                                          _c(
                                            "vab-col",
                                            {
                                              staticClass: "word_box title_box",
                                              attrs: { span: 4 },
                                            },
                                            [_vm._v(" 報告コメント ")]
                                          ),
                                          _c(
                                            "vab-col",
                                            {
                                              staticClass:
                                                "word_box word_col_input heightNormal",
                                              attrs: { span: 10 },
                                            },
                                            [
                                              _c("vab-textarea", {
                                                attrs: {
                                                  prop:
                                                    "reportDetailRcModelList." +
                                                    index +
                                                    ".reportComment",
                                                  maxlength: "1170",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "vab-col",
                                            {
                                              staticClass:
                                                "word_box word_col_input",
                                              attrs: { span: 10 },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getFieldValue(
                                                      "lastReportDetailRc.reportComment",
                                                      item
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    }
                  ),
                  _vm.showBtn
                    ? _c("div", { staticClass: "row_btm_btn" }, [
                        _c(
                          "span",
                          {
                            staticClass: "defect_addition mt12",
                            on: { click: _vm.addWorkNoReportList },
                          },
                          [
                            _c("svg-icon", { attrs: { "icon-class": "add" } }),
                            _vm._v(" 作業報告を追加 "),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "mt16 rc_boxshadow shadow_boxpadding" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "head_box flex_start flex_center_align",
                          staticStyle: { cursor: "pointer" },
                          on: {
                            click: function ($event) {
                              _vm.defectFold = !_vm.defectFold
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/r2.png"),
                              alt: "",
                            },
                          }),
                          _c(
                            "span",
                            { staticClass: "hd_title" },
                            [
                              _vm._t("hd_title", function () {
                                return [_vm._v("不具合情報")]
                              }),
                            ],
                            2
                          ),
                          _c("div", { staticClass: "pos_end" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "arrow_box flex_center_align flex_center",
                              },
                              [
                                _c("svg-icon", {
                                  staticClass: "arrow_svg",
                                  class: { rote: _vm.defectFold },
                                  attrs: { "icon-class": "up_line" },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.defectFold,
                              expression: "defectFold",
                            },
                          ],
                        },
                        [
                          _vm._l(_vm.changeDefaultList, function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "scd_cnt_box" },
                              [
                                _c("div", { staticClass: "scd_title" }, [
                                  _c("i"),
                                  _vm._v(
                                    " 不具合情報ID：" +
                                      _vm._s(item.defectReportId) +
                                      " "
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "row_out_box mb12" },
                                  [
                                    _c(
                                      "vab-row",
                                      { staticClass: "row_box" },
                                      [
                                        _c(
                                          "vab-col",
                                          {
                                            staticClass: "title_box bdt0",
                                            attrs: { span: 4 },
                                          },
                                          [
                                            _vm._v(" 場所 "),
                                            _c("i", { staticClass: "red" }, [
                                              _vm._v("*"),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "vab-col",
                                          {
                                            staticClass:
                                              "word_box nopadding2 word_flex bdt0",
                                            attrs: { span: 20 },
                                          },
                                          [
                                            _c("vab-input", {
                                              staticClass: "unset",
                                              attrs: {
                                                validate:
                                                  _vm.requireditem(item),
                                                prop:
                                                  "defectReportModelList." +
                                                  index +
                                                  ".defectIdModel.location",
                                                disabled:
                                                  !_vm.isEqualCodeEnum(
                                                    item.inspectionStatus,
                                                    _vm.$divisions
                                                      .inspectionStatusEnum
                                                      .enum_3
                                                  ) ||
                                                  _vm.$baseLodash.isNumber(
                                                    item.defectId
                                                  ),
                                                "label-error": "不具合情報場所",
                                              },
                                            }),
                                            _vm.isEqualCodeEnum(
                                              item.inspectionStatus,
                                              _vm.$divisions
                                                .inspectionStatusEnum.enum_3
                                            ) &&
                                            !item.defectId &&
                                            _vm.showBtn
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "delete",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteDefectReportList(
                                                          item,
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 削除 ")]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vab-row",
                                      { staticClass: "row_box" },
                                      [
                                        _c(
                                          "vab-col",
                                          {
                                            staticClass: "word_box title_box",
                                            attrs: { span: 4 },
                                          },
                                          [
                                            _vm._v(" 不具合内容 "),
                                            _c("i", { staticClass: "red" }, [
                                              _vm._v("*"),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "vab-col",
                                          {
                                            staticClass:
                                              "word_box word_col_input",
                                            attrs: { span: 20 },
                                          },
                                          [
                                            _c("vab-textarea", {
                                              staticClass: "height100 unset",
                                              attrs: {
                                                prop:
                                                  "defectReportModelList." +
                                                  index +
                                                  ".defectIdModel.defectContent",
                                                validate:
                                                  _vm.requireditem(item),
                                                disabled:
                                                  !_vm.isEqualCodeEnum(
                                                    item.inspectionStatus,
                                                    _vm.$divisions
                                                      .inspectionStatusEnum
                                                      .enum_3
                                                  ) ||
                                                  _vm.$baseLodash.isNumber(
                                                    item.defectId
                                                  ),
                                                "label-error": "不具合内容",
                                                maxlength: "1170",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vab-row",
                                      { staticClass: "row_box" },
                                      [
                                        _c(
                                          "vab-col",
                                          {
                                            staticClass: "word_box title_box",
                                            attrs: { span: 4 },
                                          },
                                          [_vm._v("写真")]
                                        ),
                                        _c(
                                          "vab-col",
                                          {
                                            staticClass:
                                              "word_box word_col_input word_col_upload",
                                            attrs: { span: 20 },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "word_bgF7" },
                                              [
                                                _vm.showBtn
                                                  ? _c("vab-upload", {
                                                      ref:
                                                        "defectUploadRef" +
                                                        index,
                                                      refInFor: true,
                                                      attrs: {
                                                        "upload-url":
                                                          "/api/defectPhoto/uploadFile",
                                                        "params-data": {
                                                          defectIdPlus:
                                                            item.defectId,
                                                          reportNo:
                                                            _vm.reportNo,
                                                          buildingCd:
                                                            item.buildingCd,
                                                        },
                                                        "action-item": {
                                                          item: item,
                                                          index: index,
                                                        },
                                                        "init-before": false,
                                                        disabled:
                                                          _vm.uploadDisabled(
                                                            item
                                                          ),
                                                      },
                                                      on: {
                                                        "on-success": function (
                                                          res
                                                        ) {
                                                          return _vm.successPhotoFile(
                                                            res,
                                                            index
                                                          )
                                                        },
                                                        getUploadData:
                                                          function ($event) {
                                                            return _vm.getDefectIdBeforeUpload(
                                                              item,
                                                              index
                                                            )
                                                          },
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm.changePhontFileList(item)
                                                  .length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "word_col_upload_filebox",
                                                      },
                                                      _vm._l(
                                                        _vm.changePhontFileList(
                                                          item
                                                        ),
                                                        function (file, f) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key: f,
                                                              staticClass:
                                                                "file_inner_item flex_start",
                                                            },
                                                            [
                                                              _c("svg-icon", {
                                                                staticClass:
                                                                  "arrow",
                                                                attrs: {
                                                                  "icon-class":
                                                                    "tryangle_right",
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "file_name_out_box",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "flex_colum file_name_box",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "file_name",
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.defectPhotoDownLoad(
                                                                                  item,
                                                                                  file
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                file.photoName
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "file_time",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " アップロード日時：" +
                                                                              _vm._s(
                                                                                file.createDate
                                                                              ) +
                                                                              "  " +
                                                                              _vm._s(
                                                                                file.createTime &&
                                                                                  file.createTime.substring(
                                                                                    0,
                                                                                    8
                                                                                  )
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm.showBtn
                                                                        ? _c(
                                                                            "svg-icon",
                                                                            {
                                                                              staticClass:
                                                                                "del",
                                                                              attrs:
                                                                                {
                                                                                  "icon-class":
                                                                                    "close_circle_fill",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.handleDefectPhotoDelete(
                                                                                      file,
                                                                                      item,
                                                                                      f
                                                                                    )
                                                                                  },
                                                                              },
                                                                            }
                                                                          )
                                                                        : _vm._e(),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vab-row",
                                      { staticClass: "row_box" },
                                      [
                                        _c(
                                          "vab-col",
                                          {
                                            staticClass: "title_box",
                                            attrs: { span: 4 },
                                          },
                                          [
                                            _vm._v(" 点検結果 "),
                                            _c("i", { staticClass: "red" }, [
                                              _vm._v("*"),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "vab-col",
                                          {
                                            staticClass:
                                              "word_box nopadding2 flex_center_align",
                                            attrs: { span: 20 },
                                          },
                                          [
                                            _c("vab-radio-group", {
                                              ref: "defectRadioRef" + index,
                                              refInFor: true,
                                              attrs: {
                                                label: "",
                                                "label-width": "0",
                                                validate: "required",
                                                prop:
                                                  "defectReportModelList." +
                                                  index +
                                                  ".inspectionStatus",
                                                filter: "inspectionStatus",
                                                "code-enum":
                                                  _vm.$divisions
                                                    .inspectionStatusEnum,
                                                disabled: !item.defectId,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vab-row",
                                      { staticClass: "row_box" },
                                      [
                                        _c(
                                          "vab-col",
                                          {
                                            staticClass: "title_box",
                                            attrs: { span: 4 },
                                          },
                                          [_vm._v("初回報告日")]
                                        ),
                                        _c(
                                          "vab-col",
                                          {
                                            staticClass: "word_box",
                                            attrs: { span: 20 },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getFieldValue(
                                                    "defectIdModel.firstReportDate",
                                                    item
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _vm.getFieldValue(
                                              "defectIdModel.firstReportDate",
                                              item
                                            )
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "without_experience",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.withoutExperienceDialog(
                                                          item.defectId
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("svg-icon", {
                                                      attrs: {
                                                        "icon-class": "select",
                                                      },
                                                    }),
                                                    _vm._v(" 不具合履歴 "),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          _vm.showBtn
                            ? _c(
                                "span",
                                {
                                  staticClass: "defect_addition mt12",
                                  class: _vm.changeDefaultList.length
                                    ? ""
                                    : "mt12",
                                  on: { click: _vm.addDefectReportList },
                                },
                                [
                                  _c("svg-icon", {
                                    attrs: { "icon-class": "add" },
                                  }),
                                  _vm._v(" 不具合追加 "),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  ),
                  _vm.itemDetailCd == "001" ||
                  _vm.itemDetailCd == "400" ||
                  _vm.itemDetailCd == "007"
                    ? _c(
                        "div",
                        { staticClass: "mt16 rc_boxshadow shadow_boxpadding" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "head_box flex_start flex_center_align",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function ($event) {
                                  _vm.unimplementFold = !_vm.unimplementFold
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/images/r2.png"),
                                  alt: "",
                                },
                              }),
                              _c(
                                "span",
                                { staticClass: "hd_title" },
                                [
                                  _vm._t("hd_title", function () {
                                    return [_vm._v("作業未実施住戸情報")]
                                  }),
                                ],
                                2
                              ),
                              _c("div", { staticClass: "pos_end" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "arrow_box flex_center_align flex_center",
                                  },
                                  [
                                    _c("svg-icon", {
                                      staticClass: "arrow_svg",
                                      class: { rote: _vm.unimplementFold },
                                      attrs: { "icon-class": "up_line" },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.unimplementFold,
                                  expression: "unimplementFold",
                                },
                              ],
                            },
                            _vm._l(
                              _vm.form.workImplementInfoModelList,
                              function (item, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "scd_cnt_box" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "scd_title1 flex_center_align",
                                      },
                                      [
                                        _c("i"),
                                        _vm._v(
                                          " 棟" +
                                            _vm._s(item.reportSectionCd) +
                                            "：" +
                                            _vm._s(item.blgsnmkj) +
                                            " "
                                        ),
                                        _c("vab-checkbox", {
                                          ref: "allFlagRef" + index,
                                          refInFor: true,
                                          staticClass: "ml12I",
                                          attrs: {
                                            prop:
                                              "workImplementInfoModelList." +
                                              index +
                                              ".allImplementClass",
                                            "code-enum":
                                              _vm.$divisions.boolFlagEnum,
                                            label: "全戸実施",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.isAllWorkImplementChange(
                                                item,
                                                index
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    !_vm.isEqualCodeEnum(
                                      item.allImplementClass,
                                      _vm.$divisions.boolFlagEnum.enum_1
                                    )
                                      ? [
                                          _c("div", { staticClass: "h_date" }, [
                                            _c(
                                              "span",
                                              { staticClass: "h_title" },
                                              [
                                                _vm._t("h_title", function () {
                                                  return [
                                                    _vm._v(
                                                      "未実施住戸登録を行ってください"
                                                    ),
                                                  ]
                                                }),
                                              ],
                                              2
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            { staticClass: "row_out_box mb8" },
                                            [
                                              _c(
                                                "vab-row",
                                                { staticClass: "row_box" },
                                                [
                                                  _c(
                                                    "vab-col",
                                                    {
                                                      staticClass:
                                                        "title_box bdt0",
                                                      attrs: { span: 4 },
                                                    },
                                                    [_vm._v("区画")]
                                                  ),
                                                  _c(
                                                    "vab-col",
                                                    {
                                                      staticClass:
                                                        "title_box bdt0",
                                                      attrs: { span: 4 },
                                                    },
                                                    [_vm._v(" 未実施区分 ")]
                                                  ),
                                                  _c(
                                                    "vab-col",
                                                    {
                                                      staticClass:
                                                        "title_box bdt0",
                                                      attrs: { span: 16 },
                                                    },
                                                    [_vm._v(" コメント ")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._l(
                                                item.workUnimplementInfoModelList,
                                                function (son, sonIndex) {
                                                  return _c(
                                                    "vab-row",
                                                    {
                                                      key: sonIndex,
                                                      staticClass: "row_box",
                                                    },
                                                    [
                                                      _c(
                                                        "vab-col",
                                                        {
                                                          staticClass:
                                                            "word_box word_col_input",
                                                          attrs: { span: 4 },
                                                        },
                                                        [
                                                          _c("vab-select", {
                                                            attrs: {
                                                              prop:
                                                                "workImplementInfoModelList." +
                                                                index +
                                                                ".workUnimplementInfoModelList." +
                                                                sonIndex +
                                                                ".roomNo",
                                                              "data-items":
                                                                _vm.roomList(
                                                                  item.workUnimplementInfoModelList,
                                                                  item.roomList
                                                                ),
                                                              "value-id":
                                                                "roomno",
                                                              clearable: "",
                                                              "collapse-tags":
                                                                "",
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.handleWorkUnimplementChange(
                                                                  son,
                                                                  index
                                                                )
                                                              },
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "vab-col",
                                                        {
                                                          staticClass:
                                                            "word_box word_col_input",
                                                          attrs: { span: 4 },
                                                        },
                                                        [
                                                          _c("vab-select", {
                                                            ref:
                                                              "unimplementClass" +
                                                              index +
                                                              "Ref" +
                                                              sonIndex,
                                                            refInFor: true,
                                                            attrs: {
                                                              prop:
                                                                "workImplementInfoModelList." +
                                                                index +
                                                                ".workUnimplementInfoModelList." +
                                                                sonIndex +
                                                                ".unimplementClass",
                                                              filter:
                                                                "unimplementNewClass",
                                                              clearable: "",
                                                              "collapse-tags":
                                                                "",
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.handleWorkUnimplementChange(
                                                                  son,
                                                                  index
                                                                )
                                                              },
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "vab-col",
                                                        {
                                                          staticClass:
                                                            "word_box word_col_input",
                                                          attrs: { span: 16 },
                                                        },
                                                        [
                                                          _c("vab-input", {
                                                            attrs: {
                                                              prop:
                                                                "workImplementInfoModelList." +
                                                                index +
                                                                ".workUnimplementInfoModelList." +
                                                                sonIndex +
                                                                ".comment",
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                return _vm.changeInput(
                                                                  son,
                                                                  index
                                                                )
                                                              },
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm.showBtn
                                            ? _c(
                                                "div",
                                                { staticClass: "flex_count" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "defect_addition",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.addWorkUnimplementList(
                                                            item,
                                                            index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("svg-icon", {
                                                        attrs: {
                                                          "icon-class":
                                                            "select",
                                                        },
                                                      }),
                                                      _vm._v(" 追加 "),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : _vm._e(),
                                    index ==
                                    _vm.form.workImplementInfoModelList.length -
                                      1
                                      ? _c("ul", { staticClass: "count_ul" }, [
                                          _c("li", [
                                            _c(
                                              "span",
                                              { staticClass: "count_li_name" },
                                              [_vm._v("全戸数")]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "count_li_count" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.form
                                                        .inspectionTargetRoomNum
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("li", [
                                            _c(
                                              "span",
                                              { staticClass: "count_li_name" },
                                              [_vm._v("未実施戸数")]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "count_li_count" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.form.uncheckRoomNum
                                                        ? _vm.form
                                                            .uncheckRoomNum
                                                        : 0
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("li", [
                                            _c(
                                              "span",
                                              { staticClass: "count_li_name" },
                                              [_vm._v("実施率")]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "count_li_count" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.form.checkRate) +
                                                    "％"
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
          _c(
            "div",
            { staticClass: "mt16 rc_boxshadow shadow_boxpadding" },
            [
              _c(
                "div",
                { staticClass: "head_box flex_start flex_center_align" },
                [
                  _c("img", {
                    attrs: { src: require("@/assets/images/r2.png"), alt: "" },
                  }),
                  _c(
                    "span",
                    { staticClass: "hd_title" },
                    [
                      _vm._t("hd_title", function () {
                        return [_vm._v("コメント")]
                      }),
                    ],
                    2
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "row_out_box mb12 mt12" },
                [
                  _vm._l(_vm.comList, function (item, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        item.type == "pre" &&
                        _vm.isEqualCodeEnum(
                          _vm.reportFormat,
                          _vm.$divisions.reportFormatEnum.enum_1
                        )
                          ? _c(
                              "vab-row",
                              { staticClass: "row_box" },
                              [
                                _c(
                                  "vab-col",
                                  {
                                    staticClass: "title_box bdt0",
                                    attrs: { span: 4 },
                                  },
                                  [_vm._v("速報版")]
                                ),
                                _c(
                                  "vab-col",
                                  {
                                    staticClass: "col_content word_box bdt0",
                                    attrs: { span: 20 },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col_content_box" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col_content_title" },
                                          [_vm._v("提出日")]
                                        ),
                                        item.picker
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "col_content_cont",
                                              },
                                              [
                                                _c("vab-date-picker", {
                                                  staticStyle: {
                                                    width: "140px",
                                                  },
                                                  attrs: {
                                                    type: "date",
                                                    "value-format":
                                                      "yyyy/MM/dd",
                                                    format: "yyyy/MM/dd",
                                                    prop: "prePartenrSubmitDate",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.prePartenrSubmitDate
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col_content_box" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col_content_title" },
                                          [_vm._v("結果")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "col_content_cont" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.statusName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        item.type == "off"
                          ? _c(
                              "vab-row",
                              { staticClass: "row_box" },
                              [
                                _c(
                                  "vab-col",
                                  {
                                    staticClass: "title_box",
                                    attrs: { span: 4 },
                                  },
                                  [_vm._v("正式版")]
                                ),
                                _c(
                                  "vab-col",
                                  {
                                    staticClass: "col_content word_box",
                                    attrs: { span: 20 },
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "col_content_box" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col_content_title",
                                            },
                                            [_vm._v("提出方法")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "col_content_cont" },
                                            [
                                              item.picker || item.raido
                                                ? _c("vab-radio-group", {
                                                    ref: "legalPostsendFlgRef",
                                                    refInFor: true,
                                                    attrs: {
                                                      "label-width": "0",
                                                      prop: "legalPostsendFlg",
                                                      "data-items":
                                                        _vm.$const
                                                          .legalPostsendFlg,
                                                      "label-id": "text",
                                                      "value-id": "value",
                                                    },
                                                  })
                                                : _c("div", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.legalPostsendFlg
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "col_content_box" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col_content_title",
                                            },
                                            [_vm._v("提出日")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "col_content_cont" },
                                            [
                                              item.picker
                                                ? _c("vab-date-picker", {
                                                    staticStyle: {
                                                      width: "140px",
                                                    },
                                                    attrs: {
                                                      type: "date",
                                                      "value-format":
                                                        "yyyy/MM/dd",
                                                      format: "yyyy/MM/dd",
                                                      prop: "officalPartenrSubmitDate",
                                                    },
                                                  })
                                                : _c("div", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.officalPartenrSubmitDate
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "col_content_box" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col_content_title",
                                            },
                                            [_vm._v("結果")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "col_content_cont" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.statusName) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  _c(
                    "vab-row",
                    { staticClass: "row_box" },
                    [
                      _c(
                        "vab-col",
                        { staticClass: "title_box", attrs: { span: 4 } },
                        [_vm._v("法定報告書提出日")]
                      ),
                      _c(
                        "vab-col",
                        {
                          staticClass: "col_content word_box word_col_input",
                          attrs: { span: 8 },
                        },
                        [
                          _c("vab-date-picker", {
                            staticStyle: { width: "50%" },
                            attrs: {
                              type: "date",
                              "label-show": false,
                              "value-format": "yyyy/MM/dd",
                              format: "yyyy/MM/dd",
                              prop: "legalSubmitDate",
                              disabled: !_vm.isEqualCodeEnum(
                                _vm.reportBaseInfo.officalReportStatus,
                                _vm.$divisions.reportStatusEnum.enum_11
                              ),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "vab-col",
                        { staticClass: "title_box", attrs: { span: 4 } },
                        [_vm._v("副本受領日")]
                      ),
                      _c(
                        "vab-col",
                        {
                          staticClass:
                            "col_content word_box word_col_input bdr0",
                          attrs: { span: 8 },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.reportBaseInfo.duplicateConfrimDate) +
                              " "
                          ),
                        ]
                      ),
                      _vm.btnData.show
                        ? [
                            _c(
                              "vab-col",
                              {
                                staticClass: "word_box title_box",
                                attrs: { span: 4 },
                              },
                              [_vm._v("特記事項")]
                            ),
                            _c(
                              "vab-col",
                              {
                                staticClass: "word_box word_col_input",
                                attrs: { span: 20 },
                              },
                              [
                                _vm.isEqualCodeEnum(
                                  _vm.reportFormat,
                                  _vm.$divisions.reportFormatEnum.enum_1
                                ) &&
                                !_vm.isEqualCodeEnum(
                                  _vm.reportBaseInfo.preReportStatus,
                                  _vm.$divisions.reportStatusEnum.enum_05
                                )
                                  ? _c("vab-textarea", {
                                      staticClass: "height100",
                                      attrs: {
                                        maxlength: "1000",
                                        prop: "prePartenrComment",
                                      },
                                    })
                                  : _vm._e(),
                                _vm.isEqualCodeEnum(
                                  _vm.reportFormat,
                                  _vm.$divisions.reportFormatEnum.enum_2
                                ) ||
                                _vm.isEqualCodeEnum(
                                  _vm.reportBaseInfo.preReportStatus,
                                  _vm.$divisions.reportStatusEnum.enum_05
                                )
                                  ? _c("vab-textarea", {
                                      staticClass: "height100",
                                      attrs: {
                                        maxlength: "1000",
                                        prop: "officalPartenrComment",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                2
              ),
              _c("vab-messagerc", {
                ref: "vabMessage",
                staticClass: "noborder",
                attrs: { title: "コメント履歴を閉じる" },
              }),
            ],
            1
          ),
        ]
      ),
      _c("ErrorSelect", {
        ref: "failureNo",
        attrs: { visible: _vm.novisable },
        on: {
          "update:visible": function ($event) {
            _vm.novisable = $event
          },
          handledefectNoChoose: _vm.handledefectNoChose,
        },
      }),
      _c("ErrorRecords", { ref: "errorRecords" }),
      _c("div", { staticClass: "flex_space" }, [
        _c(
          "div",
          { staticClass: "mg12 zh_btn_box flex_start flex_center_align" },
          [_c("vab-button", { attrs: { "btn-list": _vm.btnLeft } })],
          1
        ),
        _c(
          "div",
          { staticClass: "flex_start zh_btn_box mg12" },
          [_c("vab-button", { attrs: { "btn-list": _vm.btnRight } })],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }